{
    "AgentDetails_GUID": "Identificatore (GUID):",
    "AgentNumber": "Numero di agente:",
    "AgentDetails_Partition": "Partizione:",
    "AgentDetails_Description": "Descrizione:",
    "AgentDetails_UpdateExistingItems": "Aggiornare gli elementi duplicati:",
    "AgentDetails_GUIDPlaceholder": "[Assegnato automaticamente]",
    "AgentDetails_Validation_GUID": "La lunghezza massima di un GUID è di 100 caratteri",
    "AgentDetails_Validation_AgentNumber": "Deve essere fornito un numero di agente",
    "AgentDetails_Validation_Partition": "È necessario selezionare una partizione",
    "AgentDetails_NonePartition": "[Nessuno]",
    "NAME": "AgentDetails"
}